import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DonationResponse } from '@joc/api-gateway';
import { API } from '../../../core/API';
import { STORE_DONATIONS_QUERY_KEY } from '../../../core/constants';

interface IUseFeaturedDonationItem {
	// eslint-disable-next-line no-unused-vars
	setFeaturedDonationItem: ({ id }: { id: number }) => void;
	isError: boolean;
	isSuccess: boolean;
	data?: DonationResponse;
}

interface IUseChangeFeaturedDonationItem {
	// eslint-disable-next-line no-unused-vars
	changeFeaturedDonationItem: ({ prevId, nextId }: { prevId: number; nextId: number }) => void;
	isError: boolean;
	isSuccess: boolean;
	data?: DonationResponse;
}

const featuredDonationItemApi = async (id: number) => {
	return API.setFeaturedDonation(id);
};

export const useFeaturedDonationItem = (): IUseFeaturedDonationItem => {
	const queryClient = useQueryClient();
	const {
		mutate: setFeaturedDonationItem,
		data,
		isError,
		isSuccess,
	} = useMutation<DonationResponse, Error, { id: number }>({
		mutationFn: ({ id }) => featuredDonationItemApi(id),
		onSettled: () => queryClient.invalidateQueries({ queryKey: [STORE_DONATIONS_QUERY_KEY] }),
	});

	return { setFeaturedDonationItem, data, isError, isSuccess };
};

export const useChangeFeaturedDonationItem = (): IUseChangeFeaturedDonationItem => {
	const queryClient = useQueryClient();
	const {
		mutate: changeFeaturedDonationItem,
		data,
		isError,
		isSuccess,
	} = useMutation<DonationResponse, Error, { prevId: number; nextId: number }>({
		mutationFn: async ({ prevId, nextId }) => {
			await featuredDonationItemApi(prevId);
			return featuredDonationItemApi(nextId);
		},
		onSettled: () => queryClient.invalidateQueries({ queryKey: [STORE_DONATIONS_QUERY_KEY] }),
	});

	return { changeFeaturedDonationItem, data, isError, isSuccess };
};
